import React, { useEffect, useState } from "react";
import lifestyle from "../assets/articale/Happy womens.png";
import charlie from "../assets/charlie.webp";
import will from "../assets/will.webp";

const IntroducingSlimetics = () => {
  const [vid, setVid] = useState(null);

  useEffect(() => {
    function replaceVidPlaceholder() {
      if (window?.clickmagick_cmc && window?.clickmagick_cmc?.vid) {
        setVid(window?.clickmagick_cmc?.vid);
      } else {
        setTimeout(replaceVidPlaceholder, 200);
      }
    }
    replaceVidPlaceholder();
  }, []);

  return (
    <>
      <div>
        <h2 className="text-2xl font-bold text-[#303030] mb-6">
          {"Introducing Slimetics – Gut & Metabolic Support in One Simple Formula"}
        </h2>
        <div className="relative w-full mb-6">
          <img
            src={lifestyle}
            alt="Happy womens"
            className="w-full rounded-3xl border border-gray-100"
            draggable="false"
          />
        </div>
        <div className="space-y-4 text-[#303030]">
         <p>Slimetics is one of the first formulas designed to help support a balanced gut microbiome using clinically backed probiotics like Akkermansia muciniphila—helping you feel lighter, more energized, and more in control.</p>
          <p>But don’t just take our word for it…</p>
          
<div>
<h2 className="text-2xl font-bold text-[#303030] mb-6">
          {"Real People. Real Experiences."}
        </h2>
</div>


          <div className="bg-[#f0faf2] py-4">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 rounded-full overflow-hidden mr-3">
                <img
                  src={charlie}
                  alt="Laura Foster"
                  className="w-12 h-12 object-contain"
                  draggable="false"
                />
              </div>
              <div className="text-[#303030] text-sm">
                <span className="md:text-[18px] text-[13px]">
                  {"Charlotte H."}{" "}
                  <span className="text-[#417505]">{"Verified Review |"}</span>{" "}
                </span>
              </div>
              <div className=" flex items-center gap-1 px-1 py-1 rounded-full text-sm">
                <div>{" Rating: "}</div>
                <span className="md:text-xl text-sm text-yellow-400">
                  ⭐⭐⭐⭐⭐
                </span>
              </div>
            </div>
            <div className="p-4">
              <div>
                <p className="font-bold text-xl mb-2 text-[#303030]">
                "I didn’t think this would help… but it truly did."
                </p>
              </div>
              <div>
                <p style={{ lineHeight: "23px" }} className="text-[#303030]">
                "I’ve struggled with digestion and stubborn weight for years. Within days of using Slimetics, I felt less bloated and more energized. It’s like my body finally found its rhythm again."
                </p>
              </div>
            </div>
          </div>
          <div className="bg-[#f0faf2] py-4">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 rounded-full overflow-hidden mr-3">
                <img
                  src={will}
                  alt="Laura Foster"
                  className="w-12 h-12 object-contain"
                  draggable="false"
                />
              </div>
              <div className="text-gray-700 text-sm">
                <span className="md:text-[18px] text-[13px]">
                  {"William B."}{" "}
                  <span className="text-[#417505]">{"Verified Review |"}</span>{" "}
                </span>
              </div>
              <div className=" flex items-center gap-1 px-1 py-1 rounded-full text-sm">
                <div>{" Rating: "}</div>
                <span className="md:text-xl text-sm text-yellow-400">
                  ⭐⭐⭐⭐⭐
                </span>
              </div>
            </div>
            <div className="p-4">
              <div>
                <p className="font-bold text-xl mb-2 text-[#303030]">
                "My energy and digestion feel so much better."
                </p>
              </div>
              <div>
                <p style={{ lineHeight: "23px" }} className="text-[#303030]">
                "After 40, everything felt harder—especially losing weight. Slimetics made a real difference for me. I’ve noticed steady progress, more energy, and fewer cravings."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IntroducingSlimetics;
